import React, { Component } from "react";
import ReactToPrint from "react-to-print";
import "./style.css";
import printed from "../../Redux/APIs/CompanyAPIs/printed";
import { connect } from "react-redux";
import { format, parseISO } from "date-fns";
import { resolveLetterPrintSettings } from "./letterPrintDefaults";

export class Letter1 extends Component {
  state = {};
  isSignatureReq = (serviceName) => {
    let isValid = false;
    if (
      serviceName === "Premium Bonds" ||
      serviceName === "Bank" ||
      serviceName === "Private Pension"
    ) {
      isValid = true;
    }
    return isValid;
  };
  checkBankingDetails = (required) => {
    return this.props.requiredDetails?.map((reqDetail) => (
      <p key={reqDetail}>
        {reqDetail} : {required?.[reqDetail] || "__________"}
      </p>
    ));
  };

  render() {
    // Org-wide print-layout settings (mm), merged over the compliant defaults so the
    // recipient address sits inside Whistl's Engage window. Applied as scoped inline
    // styles so the shared `page` / `.l-date-details` rules used by the other letters
    // are untouched.
    const s = resolveLetterPrintSettings(this.props.printSettings);
    return (
      <page size="A4" style={{ paddingLeft: `${s.leftOffsetMm}mm` }}>
        <div className="d-flex justify-content-end mt-3 mr-5">
          <img
            src={require("../../Assets/images/print-logo.png").default || require("../../Assets/images/print-logo.png")}
            alt="logo"
            className="logoImage"
          />
        </div>
        <div className="l-address-row" style={{ marginTop: `${s.addressTopMm}mm` }}>
          <div className="l-organization-details">
            <p>{this.props.companyName && this.props.companyName}</p>
            <p>
              {this.props.companyAddress &&
                this.props.companyAddress.address1 &&
                this.props.companyAddress.address1}
            </p>
            <p>
              {this.props.companyAddress &&
                this.props.companyAddress.address2 &&
                this.props.companyAddress.address2}
            </p>
            <p>
              {this.props.companyAddress &&
                this.props.companyAddress.town &&
                this.props.companyAddress.town}
            </p>
            <p>
              {this.props.companyAddress &&
                this.props.companyAddress.postCode &&
                this.props.companyAddress.postCode}
            </p>
          </div>
          <div className="l-user-details">
            {this.props.newAddress?.split(",").map((add, i) => (
              <p key={i}>{add}</p>
            ))}
          </div>
        </div>
        <div
          className="l-date-details"
          style={{ marginTop: `${s.addressDateGapMm}mm` }}
        >
          <p>{format(new Date(), "dd MMM yyyy")}</p>
        </div>
        <h4 className="letter-heading pt-3">
          Re: Notification of change of address
        </h4>
        <div className=" pt-2 letter-main-details">
          <p style={{ textTransform: "capitalize" }}>
            Name : {this.props.name}
          </p>
          <p>
            Date of Birth :{" "}
            {this.props.dob
              ? format(parseISO(this.props.dob), "dd MMM yyyy")
              : null}
          </p>
          <p>Telephone : {this.props.phone}</p>
          <p className="pb-2">Email : {this.props?.email}</p>
          {this.props?.serviceName === "Bank"
            ? this.checkBankingDetails(this?.props?.required)
            : Object?.keys(this?.props?.required || {})?.length > 0 &&
              Object?.entries(this?.props?.required || {})?.map((obj) => (
                <p key={obj?.[0]}>
                  {obj?.[0]} : {obj?.[1]}
                </p>
              ))}
        </div>
        <div className="letter-content mt-4">
          <p>
            As of{" "}
            {this.props.movingDate
              ? format(parseISO(this.props.movingDate), "dd MMM yyyy")
              : null}{" "}
            I am no longer living at:
          </p>
          <div className="letter-content pt-3 pb-3">
            {this.props.oldAddress?.split(",").map((add, i) => (
              <p key={i}>{add}</p>
            ))}
          </div>
          <p>My new address is:</p>
          <div className="letter-content py-3">
            {this.props.newAddress?.split(",").map((add, i) => (
              <p key={i}>{add}</p>
            ))}
          </div>
          <p>
            Please ensure that you note the above information for your records
            and direct all future correspondence to my new address. I would be
            grateful if you could send me confirmation of my change of address
            via letter or email.
          </p>
          <p className="pt-4">Yours Sincerely,</p>
          <p className="pt-1">{this.props.name}</p>
          {this.isSignatureReq(this.props.serviceName) && (
            <>
              <p className="pt-4 pb-5">Signature</p>
              <div
                style={{ width: "300px", borderBottom: "1px solid black" }}
              />
            </>
          )}
        </div>
      </page>
    );
  }
}

class Letter extends Component {
  state = {};
  render() {
    return (
      <div>
        <ReactToPrint
          trigger={() => this.props.button}
          content={() => this.componentRef}
          onBeforePrint={() =>
            (document.title = `${this.props.name} | ${this.props.companyName}`)
          }
          onAfterPrint={() => {
            this.props.printed(this.props.id, this.props.requiredAPI);
            document.title =
              "Moveinout Dashboard | Change of address notifications";
          }}
        />
        <div style={{ display: "none" }}>
          <Letter1
            name={this.props.name}
            oldAddress={this.props.oldAddress}
            newAddress={this.props.newAddress}
            companyName={this.props.companyName}
            companyAddress={this.props.companyAddress}
            movingDate={this.props.movingDate}
            serviceName={this.props.serviceName}
            requiredDetails={this.props.requiredDetails}
            dob={this.props.dob}
            email={this.props.email}
            phone={this.props.phone}
            required={this.props.required}
            printSettings={this.props.printSettings}
            ref={(el) => (this.componentRef = el)}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = {
  printed,
};
export default connect(mapStateToProps, mapDispatchToProps)(Letter);
